import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {useRef} from "react";
import {StereotypeApiClient} from "../../../../../common/apis/stereotype/StereotypeApiClient";
import {ReferenceDefinitionDto} from "../../../../../common/apis/stereotype/ReferenceDefinitionDto";

export function useFindAllReferenceDefinitionsQuery(stereotypeId: string | undefined): UseQueryResult<ReferenceDefinitionDto[], any> {
    const stereotypeApiClient = useRef(new StereotypeApiClient());

    return useQuery({
        queryKey: ["stereotypes.stereotype", stereotypeId, "reference-definition"],
        queryFn: () => stereotypeApiClient.current.findAllRefDefinitions(stereotypeId!),
        enabled: !!stereotypeId,
    });
}

export function useFindReferenceDefinitionByIdQuery(stereotypeId: string, referenceDefId: string): UseQueryResult<ReferenceDefinitionDto | undefined, any> {
    const stereotypeApiClient = useRef(new StereotypeApiClient());

    return useQuery({
        queryKey: ["stereotypes.stereotype", stereotypeId, "reference-definition", referenceDefId],
        queryFn: () => stereotypeApiClient.current.findReferenceDefinitionById(stereotypeId, referenceDefId),
    });
}